import { Box } from '@factorialco/deprecated-design-system'
import { MeetingDetailPageDocument, MeetingDetailPageQuery } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import PageLoading from 'modules/layout/components/Page/Loading'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { MeetingNotes } from './Notes'
import { OldMeetingShowPage } from './OldMeetingShowPage'
import { MeetingSummary } from './Summary'
import { MeetingTasksList } from './Tasks'
import { Transcript } from './Transcript'

function MeetingDetailPage() {
  const { meetingId } = useStrictParams<'meetingId'>()
  const { company } = useCurrentSession()

  const { data, loading, error } = useQuery(MeetingDetailPageDocument, {
    variables: { id: String(meetingId), companyId: company.id },
  })

  if (loading) {
    return <PageLoading />
  }

  const hasNewMeeting = data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'dev_augment_meeting_with_ai'
  )?.enabled

  if (!hasNewMeeting) {
    return <OldMeetingShowPage />
  }

  return (
    <ResponsivePage.Body loading={!data} error={error} showHeader={false}>
      {data && <MeetingDetailPageContent data={data} />}
    </ResponsivePage.Body>
  )
}

function MeetingDetailPageContent({ data }: { data: MeetingDetailPageQuery }) {
  const meeting = data?.oneOnOnes.meeting

  if (!meeting) {
    return null
  }

  const talkingPoint = meeting.talkingPoints?.at(0)

  return (
    <Box gap="s32" width="full">
      <MeetingNotes meetingId={meeting.id} talkingPoint={talkingPoint} />
      <Transcript meeting={meeting} />
      {talkingPoint?.summary && <MeetingSummary summary={talkingPoint.summary} />}
      <MeetingTasksList meeting={meeting} />
    </Box>
  )
}

export default MeetingDetailPage
